'use strict';

const scrollAnimate = require('base/components/scrollAnimate');
const { CLASSES } = require('./../utils/globals');

const SELECTORS = {
    inputFieldWrapper: '.js-field-wrapper',
    invalidFieldMessage: '.js-invalid-message',
    isInvalid: '.is-invalid',
    select2Selection: '.select2-selection'
};

/**
 * Move keyboard focus to the first invalid field so keyboard and screen reader
 * users land on the error instead of being left on the submit button
 * (WCAG 2.4.3 Focus Order). Handles select2-enhanced dropdowns whose native
 * <select> is hidden by focusing the visible combobox instead.
 * @param {string} parentSelector - the form which contains the fields
 */
function focusFirstError(parentSelector) {
    var $invalid = $(parentSelector).find(SELECTORS.isInvalid).filter(':visible').first();
    if (!$invalid.length) {
        return;
    }

    var $control = $invalid.find('input, textarea, select').filter(':visible').first();
    if (!$control.length) {
        $control = $invalid.find(SELECTORS.select2Selection).first();
    }

    if ($control.length) {
        $control.focus();
    }
}

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 */
function loadFormErrors(parentSelector, fieldErrors) { // eslint-disable-line
    // Display error messages and highlight form fields with errors.
    $.each(fieldErrors, function (attr) {
        $('*[name=' + attr + ']', parentSelector)
            .closest(SELECTORS.inputFieldWrapper)
            .addClass(CLASSES.isInvalid)
            .find(SELECTORS.invalidFieldMessage)
            .html(fieldErrors[attr]);
    });
    // Animate to top of form that has errors
    scrollAnimate($(parentSelector));
    // Shift focus to the first field in error.
    focusFirstError(parentSelector);
}

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
    $(parentSelector).find(SELECTORS.inputFieldWrapper).removeClass(CLASSES.isInvalid);
    $(parentSelector).find(SELECTORS.invalidFieldMessage).empty();
    $('.error-message').hide();
}

module.exports = {
    loadFormErrors: loadFormErrors,
    clearPreviousErrors: clearPreviousErrors,
    focusFirstError: focusFirstError
};
